// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2C1Xe","input":"input--3VW8u"};